import { Component, OnInit, ɵɵqueryRefresh, ViewChild, ElementRef } from '@angular/core';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, ModalService, SettingsService, MarathonService } from '../_services';
import { environment } from '../../environments/environment';
import { data } from 'jquery';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
// import { DatepickerModule } from 'ng2-datepicker';
import {IAngularMyDpOptions, IMyDateModel} from 'angular-mydatepicker';

declare var jquery: any;
declare var $: any;
@Component({
    templateUrl: 'hackathon.component.html',
    styleUrls: ['hackathon.component.css']
})
export class HackathonComponent implements OnInit {

    // @ViewChild('myDpOptions', { static: false }) fromDate: any;
    myDpOptions: IAngularMyDpOptions = {
        dateRange: false,
        dateFormat: 'yyyy-mm-dd'
        // other options are here...
      };

      
    
      myDateInit: boolean = true;
      model: IMyDateModel = null;

    loginForm: UntypedFormGroup;
    loading = false;
    submitted = false;
    cancel_data: any;
    cur_page = 1;
    from = 0;
    perPage = 10;
    pageSize = 10;
    totalPages = 10;
    totalcount: any;
    search_txt = '';
    filter_date= null;
    filter_status= null;
    register_list = [];
    cat_array = [];
    category = [];
    cat_data: any;
    t_shirt = [];
    selected_category = null;
    selected_tshirt = null;
    media_domain = environment.media_domain;
    view_image = null;
    show_excel_upload = false;
    dashboad: any;
    type: any;
    pendingstate = false;
 new_page:any;
//  totalcount:any;
    @ViewChild('downloadZipLink') private downloadZipLink: ElementRef;
    pagevalue:any;
    roleId = localStorage.getItem(`${environment.appName}` + '_role');
    constructor(
        private setting: SettingsService,
        private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private modalService: ModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private _marathon: MarathonService,
        private http: HttpClient,
        private router: Router) { }
    public async reportDown(): Promise<void> {
        this.submitted = true;
        this.loading = true;
        const product = [];
       // const blob = await this._marathon.getDownload(this.cur_page, this.search_txt, this.selected_category, this.selected_tshirt);
        let binaryData = [];
     //   binaryData.push(blob);
        const url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/ms-excel' }));
        // const url = window.URL.createObjectURL(blob);
        const link = this.downloadZipLink.nativeElement;
        link.href = url;
        link.download = 'registration.xlsx';
        link.click();
        // window.URL.revokeObjectURL(url);
        this.loading = false;
        document.body.classList.remove('jw-modal-open');
        // link.stop();
    }

    ngOnInit() {
        // this._marathon.getDashboard().subscribe(data => {
        //     this.dashboad = data.data;
        // })
        this.refresh(true);

        var that = this;
    }
  

   

   

  
    edit(e, user) {
        location.href = "edit/" + user._id;
        // this.router.navigate(['/edit/' + user._id]);
    }

    

    acceptStatus(e, user) {
        e.stopPropagation();
        console.log(user)
        this._marathon.acceptUpdate(user._id, 1).subscribe(data => {
            console.log(data)
            // this._marathon.getDashboard().subscribe(data => {
            //     this.dashboad = data.data;
            // })
        })
    }
 

    refresh(reset = false) {
        // this._marathon.getDashboard().subscribe(data => {
        //     this.dashboad = data.data;
        // })


        this._marathon.getHackathon(this.cur_page,this.search_txt).subscribe(data => {
            this.register_list = data.data.docs;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
            this.totalcount = data.data.totalDocs;
            this.from = data.data.pagingCounter;
        }, error => {

        });
    }

    uploadExcelToggle(e) {
        this.show_excel_upload = true;
        this.resetFilter(null);
    }

    changeType(e) {

    }

    chooseFile(e) {

    }

   
    search(e) {

        e.stopPropagation();
        
        this.search_txt = e.target.value;
        // this.refresh();
        this._marathon.getHackathon(1,this.search_txt).subscribe(data => {
            this.register_list = data.data.docs;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
            this.totalcount = data.data.totalDocs;
            this.from = data.data.pagingCounter;
        }, error => {

        });
    }

    filterDate(e){
        console.log(e);
        // console.log(e.target.value);
        console.log(e.singleDate.formatted);
        this.filter_date=e.singleDate.formatted
        // this.filter_date=e.target.value;
        this.refresh();
    }

    filterStatus(e){
        this.filter_status=e.target.value;
        if(e.target.value == '')
        {
            this.filter_status=null;
        }
        this.refresh();
    }

    changePage(page) {
        this.cur_page = page;
      
    
            this.refresh();
      
        
    }


    resetFilter(e) {
        this.model = null;
        // this.fromDate.value = undefined;
        // this.myDpOptions.clearDate()
        // this.model = {isRange: false, singleDate: {date: { 
        //     year: 2019, 
        //     month: 5, 
        //     day: 14 
        //   }}};
        this.selected_category = null;
        this.selected_tshirt = null;
        this.search_txt = '';
        this.filter_date= null;
        this.filter_status= null;
        $('#search1').val('');
        $('#status').val('');
        $("#search1").val('')
        $("input[type=date]").val("")
        this.refresh(true);
        this._marathon.getPayment(1,this.search_txt,this.roleId,this.filter_date,this.filter_status).subscribe(data => {
            this.register_list = data.data.docs;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
            this.totalcount = data.data.totalDocs;
            this.from = data.data.pagingCounter;
        }, error => {

        });

    }

    public async downloadExcel() {

      
            // if(this.roleId == '100'){
                // const blob = await this._marathon.getPaymentListDownload(this.cur_page, this.search_txt, this.selected_category, this.selected_tshirt,"fhg");
                const blob = await this._marathon.getHackathonListDownload();
                let binaryData = [];
                binaryData.push(blob);
                const url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/ms-excel' }));
                const link = this.downloadZipLink.nativeElement;
                link.href = url;
                link.download = 'HACKATHON_LIST.xlsx';
                link.click();
            // }
        
    }

    ngAfterViewInit() {
      
    }


}
